import { render } from "./device_monitoring_and_care.vue?vue&type=template&id=5be8dca2&scoped=true"
import script from "./device_monitoring_and_care.vue?vue&type=script&lang=js"
export * from "./device_monitoring_and_care.vue?vue&type=script&lang=js"

import "./device_monitoring_and_care.vue?vue&type=style&index=0&id=5be8dca2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be8dca2"]])

export default __exports__